export const PANEL_ITEMS = [
  {
    id: 1,
    type: 'basic',
    withPanelInfo: true,
  },
  {
    id: 2,
    type: 'geo',
    name: 'geoItems',
    valid: true,
    country: 'countryItems',
    withPanelInfo: true,
  },
  {
    id: 3,
    type: 'device',
    name: 'deviceTypesWhiteItems',
    withPanelInfo: true,
    permissionKey: 'TARGET_ADD_DEVICE_TYPE',
  },
  {
    id: 4,
    type: 'iabWhite',
    name: 'iabWhiteItems',
    withPanelInfo: true,
    setAllGroup: true,
    permissionKey: 'TARGET_ADD_IAB',
  },
  {
    id: 5,
    type: 'demography',
    withPanelInfo: true,
  },
  {
    id: 6,
    type: 'domain',
    name: 'domainWhiteItems',
    withPanelInfo: true,
    permissionKey: 'TARGET_ADD_PLACEMENT',
  },
  {
    id: 7,
    type: 'page',
    name: 'pageWhiteItems',
    withPanelInfo: true,
    permissionKey: 'TARGET_ADD_PAGE',
  },
  {
    id: 8,
    type: 'carrier',
    name: 'carrierWhiteItems',
    withPanelInfo: true,
    permissionKey: 'TARGET_ADD_CARRIER',
  },
  {
    id: 9,
    type: 'model',
    name: 'makeWhiteItems',
    withPanelInfo: true,
    permissionKey: 'TARGET_ADD_MAKE',
  },
  {
    id: 10,
    type: 'connection',
    name: 'connectionTypesWhiteItems',
    withPanelInfo: true,
    permissionKey: 'TARGET_ADD_CONNECTION_TYPE',
  },
  {
    id: 11,
    type: 'bundle',
    name: 'bundleWhitelist',
    withPanelInfo: true,
  },
  {
    id: 12,
    type: 'browser',
    name: 'browserWhitelist',
    withPanelInfo: true,
  },
  {
    id: 13,
    type: 'language',
    name: 'languageWhitelist',
    withPanelInfo: true,
  },
  {
    id: 14,
    type: 'osWhite',
    name: 'osWhiteItems',
    withPanelInfo: true,
  },
  {
    id: 15,
    type: 'keyword',
    name: 'keywordWhiteItems',
    withPanelInfo: true,
  },
]

export const EXCEPTION_PANEL_ITEMS = [
  {
    id: 16,
    type: 'osBlack',
    name: 'osBlackItems',
    withPanelInfo: true,
  },
  {
    id: 17,
    type: 'iabBlack',
    name: 'iabBlackItems',
    withPanelInfo: true,
    setAllGroup: true,
  },
  {
    id: 18,
    type: 'domainBlack',
    name: 'domainBlackItems',
    withPanelInfo: true,
  },
  {
    id: 19,
    type: 'pageBlack',
    name: 'pageBlackItems',
    withPanelInfo: true,
  },
  {
    id: 20,
    type: 'ipBlack',
    name: 'ipAddressBlackItems',
    withPanelInfo: true,
  },
  {
    id: 21,
    type: 'bundleBlack',
    name: 'bundleBlacklist',
    withPanelInfo: true,
  },
  {
    id: 22,
    type: 'browserBlack',
    name: 'browserBlacklist',
    withPanelInfo: true,
  },
  {
    id: 23,
    type: 'languageBlack',
    name: 'languageBlacklist',
    withPanelInfo: true,
  },
]

export const ADVANCED_PANEL_ITEMS = [
  {
    id: 24,
    type: 'ipWhite',
    name: 'ipAddressWhiteItems',
    withPanelInfo: true,
  },
  {
    id: 25,
    type: 'safety',
    name: 'safetyItems',
    tabFirst: 'digitalLabels',
    tabSecond: 'sensitiveCategories',
    withPanelInfo: true,
    tooltipText: 'targetTooltip.safety',
    withTooltip: true,
  },
]

export const DEVICE_TOOLTIPS = {
  3: 'targetTooltip.deviceCTV',
  6: 'targetTooltip.deviceConnected',
  7: 'targetTooltip.deviceBox',
}

export const PAGE_TOOLTIPS = {
  CONTAINS: 'targetTooltip.pageContains',
  EQUALS: 'targetTooltip.pageEquals',
  STARTS_WITH: 'targetTooltip.pageStartsWith',
}

export const SAFETY_TOOLTIPS = {
  DL_G: 'targetTooltip.safetyDL_G',
  DL_MA: 'targetTooltip.safetyDL_MA',
  DL_T: 'targetTooltip.safetyDL_T',
  DL_Y: 'targetTooltip.safetyDL_Y',
  NONE_LABEL: 'targetTooltip.safetyNONE_LABEL',
}

export const AGE_ITEMS = [
  {
    text: 'ageItems.UNDER_18',
    value: 'UNDER_18',
  },
  {
    text: 'ageItems.BETWEEN_18_24',
    value: 'BETWEEN_18_24',
  },
  {
    text: 'ageItems.BETWEEN_25_34',
    value: 'BETWEEN_25_34',
  },
  {
    text: 'ageItems.BETWEEN_35_44',
    value: 'BETWEEN_35_44',
  },
  {
    text: 'ageItems.BETWEEN_45_54',
    value: 'BETWEEN_45_54',
  },
  {
    text: 'ageItems.OVER_54',
    value: 'OVER_54',
  },
  {
    text: 'ageItems.UNKNOWN',
    value: 'UNKNOWN',
  },
]

export const GENDER_ITEMS = [
  {
    text: 'genderItems.MALE',
    value: 'MALE',
  },
  {
    text: 'genderItems.FEMALE',
    value: 'FEMALE',
  },
  {
    text: 'genderItems.UNKNOWN',
    value: 'UNKNOWN',
  },
]
